/* eslint-disable import/prefer-default-export */
export const FILE_INVITATION_HEADERS = ['first_name', 'last_name', 'email']
export const FILE_INVITATION_DEPARTMENT_HEADERS = ['first_name', 'last_name', 'email', 'department']
